/**
 * Computed period duration DTO
 */
export class ComputedPeriodDurationDto {
	years?: number;
	quarters?: number;
	months?: number;
	weeks?: number;
	days?: number;
	hours?: number;
	minutes?: number;
	seconds?: number;
	milliseconds?: number;
}
